function stubArray(){return[]}module.exports=stubArray;